import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { Env, getEnvironment } from '@/api/auth/env';
import { useCallback } from 'react';
export function useEnvironmentQuery(selector, initialData) {
  const $ = _c(8);
  let t0;
  if ($[0] !== selector) {
    t0 = env => selector(env) ?? null;
    $[0] = selector;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const querySafeSelector = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["env"];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== querySafeSelector) {
    t2 = () => getEnvironment().then(querySafeSelector);
    $[3] = querySafeSelector;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== initialData || $[6] !== t2) {
    t3 = {
      queryKey: t1,
      queryFn: t2,
      initialData,
      refetchInterval: 30000
    };
    $[5] = initialData;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return useQuery(t3);
}